import { loadGlobalPages, glabalLazyPages } from "./gloabal-pages.js";
import { loadDashboardPages, dashboardLazyPages } from "./dashboard-pages.js";
import { loadBookingPages, bookingLazyPages } from "./booking-pages.js";

export const loadPages = {
  ...loadGlobalPages,
  ...loadDashboardPages,
  ...loadBookingPages,
};

const lazyPages = {
  ...glabalLazyPages,
  ...dashboardLazyPages,
  ...bookingLazyPages,
};

export default lazyPages;
